import { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { FaArrowAltCircleRight, } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';

export default function Asentamientos(){
    const { token, user } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [Asentamientos, setAsentamientos] = useState([]);
    const [barrios, setBarrios] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    useEffect(() => {
        fetchBarrios();
        fetchData();
    }, []);
    const fetchData = async () => {
        const url = `/parametros/listarasentamientos`;
        try {
        setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setAsentamientos(result.asentamientos);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const fetchBarrios = async () => {
        const url = `/parametros/barriosactivos`;
        try {
            const response = await apiService.get(url, token);
            const result = await response.data;
            setBarrios(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }    
    };
    function EditarAyuda (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('usrId', user);
        setValue('ase_asentamiento', row.ase_asentamiento);
        setValue('ase_fecha', new Date().toISOString().split('T')[0]);
        setValue('ase_barrioid', row.ase_barrioid);
        setValue('ase_activo', row.ase_activo);
    };
    const Nuevo = () =>  {
        setValue('id', 0);
        setValue('usrId', user);
        setValue('ase_asentamiento', '');
        setValue('ase_fecha', new Date().toISOString().split('T')[0]);
        setValue('ase_barrioid', '');
        setValue('ase_activo', false)
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarasentamiento';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            await fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('usrId', user);
        setValue('ase_asentamiento', '');
        setValue('ase_fecha', new Date().toISOString().split('T')[0]);
        setValue('ase_barrioid', '');
        setValue('ase_activo', false);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Asentamientos</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/parametros" >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Asentamientos</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario barrios</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    <input hidden {...register('id')}/>
                                    <input hidden {...register('usrId')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='ase_asentamiento'>Asentamiento</label>
                                                <input id='ase_asentamiento' {...register('ase_asentamiento', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Asentamiento"/>
                                                {errors.ase_asentamiento && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor="ase_barrioid">Barrio:</label>
                                                <select id="ase_barrioid" {...register('ase_barrioid', { required: true })} className='form-control'>
                                                    {barrios.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.barBarrio}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.ase_barrioid && <p style={{color: 'red'}}>Seleccione barrio</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('ase_activo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <div className='row'>
                                    <div className='col-md-2'>
                                        <button type="button" className='form-control' onClick={Nuevo}>Nuevo</button>
                                    </div>
                                </div>
                                
                                <h5 className="mb-3">Lista de asentamientos</h5>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover table-sm">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '7%' }}>Acciones</th>
                                                <th style={{ width: '7%' }}>Id</th>
                                                <th>Asentamiento</th>
                                                <th>Creado Por</th>
                                                <th>Fecha Creación</th>
                                                <th>Modificado Por</th>
                                                <th>Fecha Modificación</th>
                                                <th>Barrio Id</th>
                                                <th>Barrio</th>
                                                <th>Activo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Asentamientos.length > 0 ? (
                                                Asentamientos.map((row) => (
                                                    <tr key={row.id}>
                                                        <td>
                                                            <div className="btn-group">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-info"
                                                                    onClick={() => EditarAyuda(row)}
                                                                    data-tooltip-id='tooltiparriba'
                                                                    data-tooltip-content="Editar"
                                                                >
                                                                    <FaArrowAltCircleRight />
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td>{row.id}</td>
                                                        <td>{row.ase_asentamiento}</td>
                                                        <td>{row.ase_creadopor}</td>
                                                        <td>{row.ase_fechacreacion}</td>
                                                        <td>{row.ase_modificadopor}</td>
                                                        <td>{row.ase_echamodificacion}</td>
                                                        <td>{row.ase_barrioid}</td>
                                                        <td>{row.bar_barrio}</td>
                                                        <td>{row.ase_activo ? 'Sí' : 'No'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={2} className="text-center">No hay datos para mostrar</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}